import { getDemoData, matchRestRequest, setDemoData } from 'api/demo/utils'
import { matchPath } from 'react-router-dom'

export const mockUpdateCallout = {
  shouldMock: (request) => {
    const shouldMock = matchRestRequest(
      request,
      /\/company\/\d+\/callout\/\d+\/status\/(approve|reject)/,
      'PUT'
    )
    return shouldMock
  },
  getResponse: async (request) => {
    const match = matchPath(
      '/company/:companyId/callout/:calloutId/status/:status',
      request.url as string
    )
    const calloutId = Number(match?.params.calloutId)
    const status = match?.params.status === 'approve' ? 'approved' : 'rejected'
    const demoData = getDemoData()

    setDemoData({
      ...demoData,
      shifts: demoData.shifts.map((shift) => ({
        ...shift,
        work: shift.work?.map((work) => {
          // If this work has the callout that was approved, update both work and callout status
          const hasMatchingCallout = work.callouts?.some(
            (callout) => callout.id === calloutId
          )
          if (hasMatchingCallout && status === 'approved') {
            return {
              ...work,
              status: 'removed',
              callouts: work.callouts?.map((callout) =>
                callout.id === calloutId ? { ...callout, status } : callout
              ),
            }
          }
          // Otherwise just update the callout status if it exists
          return {
            ...work,
            callouts: work.callouts?.map((callout) =>
              callout.id === calloutId ? { ...callout, status } : callout
            ),
          }
        }),
      })),
    })

    return {
      data: {
        success: true,
        message: `Callout ${
          status === 'approved' ? 'approved' : 'rejected'
        } successfully`,
      },
    }
  },
}
